import { useMutation, useQuery } from '@tanstack/react-query';

import { api, unwrap } from '@/api/client';
import type { components } from '@/api/schema';

import { URLS_FIRMADAS } from '../curso/queries';

export type ManualViewer = components['schemas']['ManualViewer'];
export type EnarmPlus = components['schemas']['EnarmPlus'];

export const useManual = (slug: string) =>
  useQuery({
    queryKey: ['manual', slug],
    queryFn: () =>
      unwrap<ManualViewer>(api.GET('/api/v1/manuals/{slug}', { params: { path: { slug } } })),
    retry: false,
    ...URLS_FIRMADAS,
  });

export function useGuardarAvanceManual(slug: string) {
  return useMutation({
    mutationFn: (slide: number) =>
      unwrap(
        api.PUT('/api/v1/manuals/{slug}/progress', { params: { path: { slug } }, body: { slide } }),
      ),
  });
}

export const useEnarmPlus = () =>
  useQuery({
    queryKey: ['manual', 'enarm-plus'],
    queryFn: () => unwrap<EnarmPlus>(api.GET('/api/v1/manuals/enarm-plus')),
    retry: false,
    ...URLS_FIRMADAS,
  });

export function useMarcador() {
  return useMutation({
    mutationFn: (blockId: number) =>
      unwrap(api.PUT('/api/v1/manuals/enarm-plus/bookmark', { body: { blockId } })),
  });
}

/** Permiso y título de cada manual (los mismos que el menú). */
export const MANUALES: Record<string, { titulo: string; permiso: string }> = {
  algoritmos: { titulo: 'Algoritmos', permiso: 'manual.algorithms.access' },
  'ultra-resumenes': { titulo: 'Ultra Resúmenes', permiso: 'manual.ultra_summaries.access' },
  'clasificaciones-y-tablas': {
    titulo: 'Clasificaciones y Tablas ENARM',
    permiso: 'manual.tables.access',
  },
  mnemotecnias: { titulo: 'Mnemotecnias – SmartWords', permiso: 'manual.mnemonics.access' },
  'ingles-medico': {
    titulo: 'Inglés Médico – KeyPoints',
    permiso: 'manual.medical_english.access',
  },
};
